import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { MdOutlineLogout } from "react-icons/md";
import { clearUserAction } from "../../../redux/actions/userActions/userActions";
import { logo } from "../../../assets";
import SiteTitle from "../../../helpers/SiteTitle/SiteTitle";

const LogOut = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(clearUserAction());
  }, []);

  return (
    <>
      <SiteTitle title="خروج از حساب کاربری" />
      <div className="bg-[#101632] min-h-screen flex items-center justify-center p-4">
        <div className="w-full max-w-md mx-auto">
          <div className="bg-[#153477] rounded-xl shadow-lg overflow-hidden border border-gray-200">
            {/* Logo Header */}
            <div className="bg-[#153477] py-6 flex flex-col items-center border-b border-gray-200">
              <img
                src={logo}
                alt="Website Logo"
                width={80}
                className=" border-2 border-yellow-500"
              />
              <h2 className="text-2xl font-bold text-white mt-4">
                خروج از حساب کاربری
              </h2>
              <p className="text-gray-500 text-sm mt-1">شادمهر</p>
            </div>

            <div className="p-6">
              <div className="flex flex-col items-center justify-center text-center py-8">
                <MdOutlineLogout size={80} className="text-yellow-500 mb-6" />
                <p className="text-xl font-medium text-white mb-2">
                  لطفا منتظر بمانید!
                </p>
                <p className="text-white">
                  شما درحال خروج از حساب کاربری می باشید
                </p>

                {/* Loading spinner */}
                <div className="mt-6 w-12 h-12 border-4 border-yellow-500 border-t-transparent rounded-full animate-spin"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default LogOut;
